import type { SVGProps } from 'react';

const SvgListLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M7.79961 8.39985H16.1996M7.79961 11.9999H16.1996M7.79961 15.5999H16.1996M4.64961 20.3999H19.3496C19.9295 20.3999 20.3996 19.8626 20.3996 19.1999V4.79985C20.3996 4.13711 19.9295 3.59985 19.3496 3.59985H4.64961C4.06971 3.59985 3.59961 4.13711 3.59961 4.79985V19.1999C3.59961 19.8626 4.06971 20.3999 4.64961 20.3999Z'
      stroke='currentColor'
      strokeLinecap='round'
    />
  </svg>
);
export default SvgListLt;
